import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption } from '@floori-web-components';

@Pipe({
    name: 'multiselectName',
    standalone: true,
})
export class MultiselectNamePipe implements PipeTransform {
    transform(value: SelectOption[], maxItemsToShow: number = 2, moreTranslation = 'more'): string {
        if (value && value.length > 0) {
            if (value.length <= maxItemsToShow) {
                let result = '';
                value.forEach(option => {
                    result += option.label + ', ';
                });

                if (result.endsWith(', ')) {
                    result = result.slice(0, -2);
                }

                return result;
            } else {
                let result = '';
                for (let i = 0; i < maxItemsToShow; i++) {
                    result += value[i].label + ', ';
                }

                const remainingCount = value.length - maxItemsToShow;
                result += `+ ${remainingCount} ${moreTranslation}`;

                return result;
            }
        }

        return '';
    }
}
